// extracted by mini-css-extract-plugin
module.exports = {"footer":"_5d875e7","attribute":"_2630227","attributeName":"_3896ae5","attributeValue":"_9f32ae4"};